import { chakra, Text } from "@chakra-ui/react"

export const BText = chakra(Text, {
  baseStyle: {
    fontFamily: "GT Walsheim",
  },
})
